import React from "react";
import { CheckSquareFilled, FolderOpenFilled, CheckCircleFilled, CheckCircleOutlined, FileTextFilled, FileTextOutlined } from "@ant-design/icons";
import get from "lodash/get";
import {
  Menu,
  SubMenu,
  StyledLink,
  MenuItem,
  Container,
  StyledTutorialText,
  StyledTutorialNameContainer,
  StyledText,
  // StyledDashboardLinkContainer,
} from "./styled";

const TableOfContents = ({ tutorials, subjectId, selectedTutorialId, selectedLearningUnitId, collapse }) => {
  const renderSubMenu = (tutorial) => {
    // a tutorial is considered completed if all its learning units are marked as completed
    const isTutorialCompleted = get(tutorial, "studentTutorials.0.status") === "Completed";
    const tutorialName = get(tutorial, "subjectTutorials.0.displayName", tutorial.name) || tutorial.name;
	return {
		key: `toc-${tutorial._id}`,
		label: (
		  <StyledTutorialNameContainer>
            {isTutorialCompleted ? <CheckSquareFilled /> : <FolderOpenFilled />}
            <StyledTutorialText>{tutorialName}</StyledTutorialText>
          </StyledTutorialNameContainer>
		),
		children: [
		  ...tutorial.learningUnits
          .filter((lu) => !lu.isArchived)
          .map((learningUnit) => {
            const isLearningUnitCompleted = get(learningUnit, "studentLearningUnits.0.status") === "Completed";
            const learningUnitName = get(learningUnit, "subjectAssessments.0.displayName", learningUnit.name) || learningUnit.name;
            return {
              key: `tocMenuItem-${tutorial._id}-${learningUnit._id}`,
			  label: (
                <StyledLink to={`/sbj${subjectId}/tut${tutorial._id}/buildlearningunit${learningUnit._id}`} className="learning-unit-link">
                  {isLearningUnitCompleted
                    ? selectedLearningUnitId === learningUnit._id ? <CheckCircleFilled /> : <CheckCircleOutlined />
                    : selectedLearningUnitId === learningUnit._id ? <FileTextFilled /> : <FileTextOutlined />
                  }
                  <StyledText>{learningUnitName}</StyledText>
                </StyledLink>
			  )	
			};
          })
		]
	};
  };
  
  return (
    <Container>
      <Menu
        selectedKeys={[selectedLearningUnitId]}
        defaultOpenKeys={collapse ? [] : [`toc-${selectedTutorialId}`]}
        forceSubMenuRender={true}
        mode="inline"
		items={!!tutorials ? tutorials.map((tutorial) => renderSubMenu(tutorial)) : []}
      >
      </Menu>
    </Container>
  );
};

export default TableOfContents;
